import { Boat } from './boats'

export type PremiumBoat = {
  id: string
  name: string
  image: string
  gallery?: string[]
  specs: {
    capacity: string
    length: string
  }
  prices: {
    duration: string
    amount: string
  }[]
}

/**
 * Premium yachts featured exclusively in the PremiumFleet section.
 * Source of truth for both PremiumFleet.tsx and BoatFinderQuiz.tsx.
 */
export const PREMIUM_BOATS: PremiumBoat[] = [
  {
    id: 'monaco',
    name: 'MONACO',
    image:
      'https://cdn.magicpatterns.com/uploads/9RE5biBKDJtDHsAiTNpo9T/catanaran_flash.jpg',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/9RE5biBKDJtDHsAiTNpo9T/catanaran_flash.jpg',
      'https://cdn.magicpatterns.com/uploads/ewcX5hFZHNFnwW1WtV1S86/monaco.jpg',
      'https://cdn.magicpatterns.com/uploads/oHPzr1nYRDYj1LAnNWppzi/IMG_5850_2.jpg',
      'https://cdn.magicpatterns.com/uploads/hn47MK5q5xdaMY14kBAhei/IMG_5851_2.jpg',
      'https://cdn.magicpatterns.com/uploads/vDoLnFgGMgDpd9J9qWKrTm/IMG_5852_2.jpg',
    ],
    specs: {
      capacity: '12',
      length: '13',
    },
    prices: [
      { duration: '2H', amount: '550€' },
      { duration: '4H', amount: '950€' },
      { duration: '8H', amount: '1.750€' },
    ],
  },
  {
    id: 'diamonte',
    name: 'DIAMONTE',
    image:
      'https://cdn.magicpatterns.com/uploads/1TkdfuvVWVR2n4W6PHEKMa/IMG_5845_2.jpg',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/1TkdfuvVWVR2n4W6PHEKMa/IMG_5845_2.jpg',
      'https://cdn.magicpatterns.com/uploads/8zYD6SWBaUo4FQek5eSPo7/IMG_5846_2.jpg',
      'https://cdn.magicpatterns.com/uploads/oNosHaCqECgDffnq8kZqWS/IMG_5847_2.jpg',
      'https://cdn.magicpatterns.com/uploads/f5wZdRrbGUvKT4Kvcp3Rah/IMG_5848_2.jpg',
    ],
    specs: {
      capacity: '11',
      length: '14',
    },
    prices: [
      { duration: '2H', amount: '500€' },
      { duration: '4H', amount: '850€' },
      { duration: '8H', amount: '1.350€' },
    ],
  },
  {
    id: 'lagoon',
    name: 'LAGOON 450',
    image:
      'https://cdn.magicpatterns.com/uploads/kDXEMwAjS7wTNtgSHngto1/lagoon-torrevela.jpg',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/kDXEMwAjS7wTNtgSHngto1/lagoon-torrevela.jpg',
      'https://cdn.magicpatterns.com/uploads/3ChECCns28MPE3ZxAL3BQJ/lagoon-popa-1.jpg',
    ],
    specs: {
      capacity: '12',
      length: '15',
    },
    prices: [
      { duration: '4H', amount: '1.400€' },
      { duration: '8H', amount: '2.500€' },
    ],
  },
  {
    id: 'puravida',
    name: 'PURA VIDA',
    image:
      'https://cdn.magicpatterns.com/uploads/nHK7ubo7Ft7GWgFU3mDaii/pura_vida_.webp',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/nHK7ubo7Ft7GWgFU3mDaii/pura_vida_.webp',
      'https://cdn.magicpatterns.com/uploads/5kMmWb69ubUApEsFtrdUXA/pura_vida_2_.webp',
      'https://cdn.magicpatterns.com/uploads/fV3KJEgqs5qV4hQX2oDS4u/pura_vida_3.webp',
      'https://cdn.magicpatterns.com/uploads/oXcs4dpJwYVBeB5xoF8ZJu/pura_vida_4.webp',
    ],
    specs: {
      capacity: '11',
      length: '15',
    },
    prices: [
      { duration: '4H', amount: '1.400€' },
      { duration: '8H', amount: '2.200€' },
    ],
  },
]

/**
 * Adapter that exposes premium yachts in the unified Boat shape so the
 * BoatFinderQuiz can score them alongside the FleetCatalog boats.
 */
export const PREMIUM_BOATS_AS_BOATS: Boat[] = PREMIUM_BOATS.map((b) => ({
  id: b.id,
  name: b.name,
  category: 'premium',
  specs: {
    length: b.specs.length,
    engine: '',
    capacity: b.specs.capacity,
    // Premium yachts ALWAYS include a professional skipper, so the customer
    // does not need their own license.
    licenseReq: false,
    location: 'Torrevieja',
  },
  licenseBanner: 'boat.banner.skipperIncluded',
  prices: b.prices.map((p) => {
    const key =
      p.duration === '2H'
        ? 'boat.duration.2h'
        : p.duration === '4H'
          ? 'boat.duration.4h'
          : p.duration === '8H'
            ? 'boat.duration.8h'
            : p.duration
    return { label: key, price: p.amount }
  }),
  descKey: `premium.boat.${b.id}.desc`,
  image: b.image,
  gallery: b.gallery,
}))
